import { Component, OnInit } from '@angular/core';
import {ConnecttocrudService} from '../connecttocrud.service';
import {ActivatedRoute} from '@angular/router';
import {ConfService} from '../conf.service';

@Component({
  selector: 'app-docseditor',
  templateUrl: './docseditor.component.html',
  styleUrls: ['./docseditor.component.scss']
})
export class DocseditorComponent implements OnInit {
  constructor(private _service: ConnecttocrudService, private route: ActivatedRoute, private confPost: ConfService) { }
  _terms: any;
  full: any;
  title: any;
  display = [];
  selected: any;
  edit = false;
  temp: any;
  index = false;
  data: any;
  schema = {
    'Title' : '',
    'Description': '',
    'SubSection': []
  };
  subSection = {
    'Title' : '',
    'Description': '',
    'SubSection': [],
  };
  section1: any;
  ngOnInit() {
    this._service. getItemswithParameter('v1', 'services', 'services', 'documentor', null).subscribe(response =>{
      this.full = response;
      for (let i = 0; i < this.full.length; i++) {
        let flag = false;
        for (let j = 0; j < this.display.length; j++) {
          if (this.full[i].CategoryName !== undefined) {
            if (this.full[i].CategoryName === this.display[j].CategoryName) {
              flag = true;
              this.display[j].CategoryGroup.push(this.full[i]);
            }
          } else {
            if ('Default' === this.display[j].CategoryName) {
              flag = true;
              this.display[j].CategoryGroup.push(this.full[i]);
            }
          }
        }
        if (flag === false) {
          if (this.full[i].CategoryName === undefined) {
            this.display.push({'CategoryName': 'Default', 'CategoryGroup': [this.full[i]]});
          } else {
            this.display.push({'CategoryName': this.full[i].CategoryName, 'CategoryGroup': [this.full[i]]});
          }
        }
      }
      this.route.queryParams.subscribe(params => {
        if (params.title === undefined) {
        this.title = this.full[0].Title;
          this._service.getItemswithParameter('v1', 'services', 'services', 'documentor', 'Title=' + this.title).subscribe(response => {
           this.temp = response[0];
            let obj = {
              'Description': this.temp.Description,
              'Sections': this.temp.Sections
            };
            this._terms = obj;
            this.data = this._terms;
            this.section1 = this.data.Sections;
          });
        } else {
          this.title = params.title;
          this.edit = params.edit;
          this._service.getItemswithParameter('v1', 'services', 'services', 'documentor', 'Title=' + this.title).subscribe(response => {
            this.temp = response[0];
            let obj = {
              'Description': this.temp.Description,
              'Sections': this.temp.Sections
            };
            this._terms = obj;
            this.data = this._terms;
            this.section1 = this.data.Sections;
          });
        }
      });
    });
  }
  saveDescription(title, value) {
    this.data[title] = value;
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }
  tabChanged(value) {
    if (value.index !== 0) {
      this.index = true;
    } else {
      this.index = false;
    }
  }
  Saveedit() {
    this._terms.id = this.temp.id;
    this._terms.Title = this.temp.Title;
    this.confPost.patchItemServices('v1','documentor', this._terms , this._terms.id).subscribe(res => {
      alert('Updation Succesful');
    }, err=> {
      alert('Error. Please try again later');
    });
  }
}
